import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { getManagementGroupLevels } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
const parseExperimentTemplates = (experimentTemplatesDto) => {
  const result = [];
  if (!experimentTemplatesDto) {
    return result;
  }
  Object.keys(experimentTemplatesDto).forEach((k) => {
    const templateDto = experimentTemplatesDto[k];
    if (!!templateDto) {
      result.push({
        name: k || "",
        displayName: templateDto.Title || "",
        bullets: templateDto.BulletPoints || [],
        description: templateDto.Description || "",
        displayOrder: templateDto.DisplayOrder || 1e4,
        // If displayOrder is not given, assume a large value to push the template in the end
        isFeatureRollout: templateDto.IsFeatureRollout || templateDto.StudyType === "FeatureRollout" || templateDto.StudyType === "RolloutTarget" || templateDto.StudyType === "RolloutRoot" || false,
        isHidden: templateDto.IsHidden || false,
        isNew: templateDto.IsNew || false,
        isRecommended: templateDto.IsRecommended || false,
        studyType: templateDto.StudyType || "",
        workflow: templateDto.Workflow,
        creationType: templateDto.CreationType || ""
      });
    }
  });
  return result;
};
const convertToWorkspaceGroup = (userAffinity, workspaceId) => {
  return !!userAffinity ? {
    workspaceId: EnvironmentService.getWorkspaceIdOrDefault(userAffinity == null ? void 0 : userAffinity.WorkspaceId),
    managementGroup: (userAffinity == null ? void 0 : userAffinity.ManagementGroup) || ""
  } : {
    workspaceId,
    managementGroup: ""
  };
};
const tenantFromManagementGroup = (managementGroup) => {
  return getManagementGroupLevels(managementGroup).level1;
};
export {
  convertToWorkspaceGroup,
  parseExperimentTemplates,
  tenantFromManagementGroup
};
//# sourceMappingURL=TemplateSelectionUtils.js.map
